import { useEffect } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { empresaLimpiar} from "../../actions/empresas/empresas";
import { useForm } from "../../hooks/useForm";
import { Box, Grid, Typography, Divider, Button } from "@material-ui/core";
import { fetchEmpresaXCUITComunicacion, getMensajesComunicacion, getSolicitudesComunicacion, nuevoMensajeComunicacion } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import moment from "moment/moment";
import { AREAS_USUARIOS, ESTADOS_BANDEJAS_SUSPENSION } from "../../utils/constants";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useState } from "react";
import { ModalDocumentacionComunicacion } from "./Documentacion/ModalDocumentacionComunicacion";
import { DocumentacionComunicacionConEmpresas } from "./Documentacion/DocumentacionComunicacionConEmpresas";


const formInicial = {
    mensaje: ""
}
export const FormContestarMsjComunicacion = (props) => {
    const dispatch = useDispatch();

    const { mensajesComunicacion, estadoComunicacionActual, empresaSeleccionada,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta } = useSelector((state) => state.comunicacionEmpresas);
    const { areas: areasUsuario } = useSelector((state) => state.auth);
    const tieneAreaAfiliaciones = areasUsuario.find((area) => area.idArea === AREAS_USUARIOS.NACIONAL);

    const [openDocumentacion, setDocumentacionAlta] = useState(false);
    const [formValues, handleInputChange] = useForm(formInicial);

    useEffect(() => {
        dispatch(getMensajesComunicacion(props.item?.id))
    }, [dispatch, props.item?.id])

    useEffect(() => {
        dispatch(fetchEmpresaXCUITComunicacion(props.item?.cuit))
    }, [dispatch, props.item?.cuit])


    const handleSave = () => {
        const data = {
            Cuit: empresaSeleccionada.cuit,
            Mensaje: formValues.mensaje,
            IdDestino: tieneAreaAfiliaciones ? AREAS_USUARIOS.MESA_DE_AYUDA : AREAS_USUARIOS.NACIONAL,
            IdOrigen: tieneAreaAfiliaciones ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA,
            IdAreaUsuario: tieneAreaAfiliaciones ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA
        }
        dispatch(nuevoMensajeComunicacion(data, estadoComunicacionActual));
        dispatch(props.cerrarModal);
    };
    const handleCancel = () => {
        dispatch(empresaLimpiar());
        dispatch(props.cerrarModal)
        dispatch(getSolicitudesComunicacion(estadoComunicacionActual, null,tieneAreaAfiliaciones ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta))
    }
    return (
        <>
            {
                openDocumentacion && (
                    <ModalDocumentacionComunicacion
                        open={openDocumentacion}
                        closeModalHandler={() => { setDocumentacionAlta(false); }}
                        cuit={empresaSeleccionada?.cuit}
                    />
                )
            }
            <ValidatorForm onSubmit={handleSave}>
                <Grid container style={{ padding: 25 }}>
                    <Grid item xs={12} md={12} style={{ marginBottom: '1rem' }}>
                        <Typography>Datos de la empresa consultada</Typography>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={12} md={3} >
                        <TextValidator
                            value={empresaSeleccionada?.cuit || ""}
                            name="cuit"
                            label="Cuit"
                            onChange={handleInputChange}
                            autoComplete="off"
                            fullWidth
                            disabled={true}
                            validators={["required"]}
                        />
                    </Grid>
                    <Grid item xs={12} md={8} style={{ marginLeft: '0.5rem' }}>
                        <TextValidator
                            value={empresaSeleccionada?.denominacion || ""}
                            name="denominacion"
                            label="Asociacion"
                            autoComplete="off"
                            onChange={handleInputChange}
                            fullWidth
                            disabled={true}
                            validators={["required"]}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <TextValidator
                            value={empresaSeleccionada?.telefono || ""}
                            name="telefono"
                            label="Telefono"
                            autoComplete="off"
                            fullWidth
                            disabled={true}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ marginLeft: '0.5rem' }}>
                        <TextValidator
                            value={empresaSeleccionada?.email || ""}
                            name="mail"
                            label="Email"
                            autoComplete="off"
                            fullWidth
                            onChange={handleInputChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                        <Typography>Mensajes anteriores</Typography>
                        <Divider></Divider>
                    </Grid>
                    {mensajesComunicacion.length > 0 && (
                        mensajesComunicacion.map((item) => {
                            return (
                                <Grid item xs={12} md={12} >
                                    <TextValidator
                                        value={`${moment(item.fecha).format("DD/MM/YYYY HH:mm")} - ${item?.mensaje} - ${item.nombreUsuario}` || ""}
                                        label="Mensajes anteriores"
                                        autoComplete="off"
                                        fullWidth
                                        disabled={true}
                                        multiline={true}
                                        rows={1}
                                        rowsMax={8}
                                    />
                                </Grid>
                            )
                        })
                    )}
                    <Grid item xs={12} md={12} style={{ marginTop: '1rem' }}>
                        <Typography>Tu respuesta</Typography>
                        <Divider></Divider>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        { Number(estadoComunicacionActual) !== ESTADOS_BANDEJAS_SUSPENSION.CASOS_CERRADOS ? (
                            <Box>
                                <Grid>
                                    <TextValidator
                                        value={formValues.mensaje || ""}
                                        onChange={handleInputChange}
                                        margin="normal"
                                        label="Respuesta"
                                        name="mensaje"
                                        autoComplete="off"
                                        validators={["required"]}
                                        fullWidth
                                        errorMessages={["La respuesta es requerida"]}
                                        multiline={true}
                                        rows={3}
                                        rowsMax={8}
                                    />
                                </Grid>
                            </Box>
                        ) : (<Typography>{`No puedes volver a enviar mensajes, el caso está cerrado.`}</Typography>)}

                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                        <Divider></Divider>
                        <Typography>Documentacion</Typography>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginTop: '1rem' }} >
                        <DocumentacionComunicacionConEmpresas cuit={empresaSeleccionada?.cuit} />
                    </Grid>
                    <Grid container style={{ padding: 25 }} >
                        <Grid item xs={12}>
                            <Grid
                                container
                                spacing={1}
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                >
                                    CANCELAR
                                </Button>
                                { Number(estadoComunicacionActual) !== ESTADOS_BANDEJAS_SUSPENSION.CASOS_CERRADOS && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<SaveIcon />}
                                        type='submit'
                                        style={{ marginLeft: "0.5rem" }}
                                    >
                                        ENVIAR
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </>
    );
}